<app-onb-moldura passo="receber" [estado]="estado" subtitulo="Escolha o aparelho que fica com você durante o expediente. Quando chegar pedido, ele toca.">

  <div class="pr-aparelhos" id="onb-aparelhos">
    <button type="button" class="pr-aparelho" [class.on]="dispositivo === 'CELULAR'" (click)="escolha('CELULAR')">
      <span class="onb-ic onb-ic--receber"><i class="fas fa-mobile-alt"></i></span>
      <b>No celular</b>
      <span>Para quem está sempre com o celular na mão.</span>
    </button>
    <button type="button" class="pr-aparelho" [class.on]="dispositivo === 'COMPUTADOR'" (click)="escolha('COMPUTADOR')">
      <span class="onb-ic onb-ic--loja"><i class="fas fa-desktop"></i></span>
      <b>No computador</b>
      <span>Para balcão ou caixa, com impressora.</span>
    </button>
  </div>

  <div class="pr-longe" *ngIf="dispositivo === 'CELULAR'">
    <span class="pr-av"><i class="fas fa-mobile-alt"></i></span>
    <div>
      <b>Deixe o painel aberto e a tela ligada</b>
      <span>O som de pedido novo toca com esta tela aberta no navegador. Com o celular bloqueado ou em outro app, ele não toca: durante o expediente, deixe o painel na frente e o celular carregando.</span>
    </div>
  </div>

  <div class="pr-longe" *ngIf="computadorLonge">
    <span class="pr-av">M</span>
    <div>
      <b>Abra o painel no computador</b>
      <span>No computador, entre no WhatsApp Web e toque no mesmo link que a Mia te mandou: ele vale 7 dias e não pede senha. Lá você instala a extensão e a impressora.</span>
    </div>
  </div>

  <div class="onb-grupo-rot">Para não perder pedido</div>
  <div class="onb-grupo">
    <div class="onb-linha">
      <span class="onb-ic onb-ic--receber"><i class="fas fa-volume-up"></i></span>
      <div class="onb-tx"><b>Som de pedido novo</b><span>{{ somTestado ? 'Funcionando. Deixe o volume alto.' : 'Toque para ouvir como vai soar.' }}</span></div>
      <button type="button" class="onb-btn" id="onb-testar-som" [class.onb-btn--pri]="!somTestado" [class.onb-btn--sec]="somTestado" (click)="testeSom()">
        {{ somTestado ? 'Tocar de novo' : 'Testar som' }}
      </button>
    </div>
    <div class="onb-linha" *ngIf="suportaNotificacao">
      <span class="onb-ic onb-ic--horarios"><i class="fas fa-bell"></i></span>
      <div class="onb-tx">
        <b>Aviso na tela</b>
        <span *ngIf="!notificacaoNegada">Mostra o pedido mesmo com outra aba aberta.</span>
        <span *ngIf="notificacaoNegada">O navegador bloqueou. Libere no cadeado ao lado do endereço do site.</span>
      </div>
      <span class="onb-pill onb-pill--ok" *ngIf="notificacao">Ativado</span>
      <button type="button" class="onb-btn onb-btn--sec" *ngIf="!notificacao" (click)="permitaNotificacao()">Permitir</button>
    </div>
  </div>

  <app-onb-equipamentos *ngIf="mostraEquipamentos" [estado]="estado" (mudou)="atualizou.emit($event)" (ajuda)="ajuda.emit($event)">
  </app-onb-equipamentos>

  <div class="onb-erro" *ngIf="erro">{{ erro }}</div>

  <div class="onb-rodape">
    <span class="onb-dica">{{ !somTestado ? 'Teste o som antes de continuar' : 'Ao salvar, Pedidos entra no seu menu' }}</span>
    <a class="onb-btn onb-btn--link" routerLink="/admin/comecar">Fazer depois</a>
    <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="salve()">
      {{ salvando ? 'Salvando…' : 'Salvar e continuar' }}
    </button>
  </div>
</app-onb-moldura>
